// extracted by mini-css-extract-plugin
module.exports = {"intro":"BillingAddress_intro__FH_4f","hidden":"BillingAddress_hidden__IB5lI","messageBox":"BillingAddress_messageBox__WcT8G"};